import React from 'react';
import styled from 'styled-components';
import { Body5 } from '@ui';
import { AgentScriptResult } from '@containers/results/AgentScriptResult';

const CellWrapper = styled.td``;

export function AgentCellAnswer({ data: cellData, isLastCellInRow, onResultComplete }) {
  const { childResultId, isDiffModeRow } = cellData;

  if (isLastCellInRow && isDiffModeRow) {
    return (
      <CellWrapper className={'response'}>
        <Body5></Body5>
      </CellWrapper>
    );
  }

  return (
    <CellWrapper className={'response'}>
      <AgentScriptResult resultId={childResultId} onResultComplete={onResultComplete} />
    </CellWrapper>
  );
}
